import ArrowDown from 'assets/svgs/ArrowDown'
import ArrowUp from 'assets/svgs/ArrowUp'
import Sidebar from 'components/global/sidebar'
import Navbar from 'components/user/navbar'
import bilboards from 'data/bilboards'
import React from 'react'

const Cart = () => {
    return (
        <div className="w-full pb-20 md:px-0 px-4 pt-24  ">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl md:pr-20 ">
                <div className='light-shadow rounded-md sm:px-4 px-2'>
                    <div className='border-b py-4 font-semibold text-lg'>
                        Shopping Cart
                    </div>
                    <div>
                        <div className='mt-4 text-sm flex flex-col gap-1'>
                            <p>Shopping Cart Details</p>
                            <p className='text-[13px]'>You have 3 items in your cart</p>
                        </div>
                        <div className='flex flex-col gap-4 mt-8'>
                            {
                                bilboards?.slice(0,3)?.map((item,i) => (
                                    <div className='flex items-center justify-between gap-4 light-shadow py-3 px-2 rounded-md sm:pr-6'>
                                        <div className='flex items-center gap-3'>
                                            <div>
                                                <img 
                                                src={item} 
                                                alt="cart item" 
                                                className='sm:w-[70px] sm:h-[70px] w-[50px] h-[50px] rounded-md object-cover'
                                                />
                                            </div>
                                            <div >
                                                <p className='sm:text-sm text-xs'>Italy Pizza Shop</p>
                                                <p className='mt-1 text-xs text-dark'>Digital Ad</p>
                                            </div>
                                        </div>
                                        <div className='flex items-center sm:gap-8 gap-4'>
                                            <div className='flex items-center gap-2'>
                                                <p>1</p>
                                                <div>
                                                    <div className='cursor-pointer'
                                                    >
                                                        <ArrowUp />
                                                    </div>
                                                    <div className='cursor-pointer'>
                                                        <ArrowDown />
                                                    </div>
                                                </div>
                                            </div>
                                            <p className='text-primary'>$20</p>
                                            <div className='text-xl text-red-500 cursor-pointer'>
                                                <i className="uil uil-trash"></i>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div className='py-8 flex items-center justify-center'>
                            <button className="btn-primary py-2 ">
                                Create Compaign
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cart